var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'text-success': _vm.satisfied}},[_c('i',{staticClass:"far mx-2",class:{'fa-square': !_vm.satisfied, 'fa-check-square': _vm.satisfied},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }